import { render, staticRenderFns } from "./informations-marche.vue?vue&type=template&id=4f1ba66c&scoped=true&"
import script from "./informations-marche.vue?vue&type=script&lang=ts&"
export * from "./informations-marche.vue?vue&type=script&lang=ts&"
import style0 from "./informations-marche.vue?vue&type=style&index=0&id=4f1ba66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ba66c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
